import FormInput from 'components/ui/composed/declarations/formInput/DeclarationInput';
import CountrySelect from 'components/ui/composed/declarations/CountrySelect';
import useCodelists from 'hooks/useCodelists';
import useTooltips from 'hooks/useTooltips';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import { getFormikProps, handleToggleHelp } from 'views/declarations/utils/form-utils';
import NewFormCard, { FormCardContainer } from '../../../../common/cards/NewFormCard';

const GoodsShipmentCard: FC<DeclarationFormCardProps> = (props) => {
    const { t } = useTranslation('form');
    const { getH1TooltipsByRefNumberAndField } = useTooltips();
    const { aisCodelists } = useCodelists();

    return (
        <NewFormCard title={t('goodsShipment.title')}>
            <FormCardContainer>
                <CountrySelect
                    viewOnly={props.viewOnly}
                    {...getFormikProps(`regionDestination`, props)}
                    refNumber="5.9"
                    label={t('regionDestination')}
                    tooltip={getH1TooltipsByRefNumberAndField('5.9', t('regionDestination'))}
                    refClicked={(ref) => handleToggleHelp(ref, props)}
                    selectOptions={aisCodelists?.destinationRegionCode}
                    condensed
                />
            </FormCardContainer>
        </NewFormCard>
    );
};
export default GoodsShipmentCard;
